/**
 *
 *
 */

jQuery(document).ready(function(){
  
  
  	/* Execute ColorBox Gallery */
  	var cbSettings = {
        rel: 'gallery',
      	height: 'auto',
      	maxHeight: '95%',
      	maxWidth: '95%',
      	width: 'auto',
        transition: 'none', 
      	loop: 'true',
        onOpen: function() {
            $("#colorbox").wrap("<div id='colorbox_wrapper' />");
            /* $("#cboxClose").unbind();  */
        },
      	
		onCleanup: function() {
            $("#colorbox").unwrap("<div id='colorbox_wrapper' />");
        },

      
      	title: function() {
            return $(this).find('img').attr('alt');
        }
    }
  
    jQuery(".gallery").colorbox(cbSettings);
  
  	//Keep lightbox responsive on screen resize
    jQuery(window).on('resize', function() {
        jQuery.colorbox.resize({
            width: window.innerWidth > parseInt(cbSettings.maxWidth) ? cbSettings.maxWidth : cbSettings.width
        });
    });
  
  
  	/* Close windown and remove wrapper */
  	$("#cboxClose, #colorbox_wrapper").click(function() {
      	$('#colorbox').unwrap("<div id='colorbox_wrapper' />");
    });
  
  
  	/* Other Scripts Here... */
  

});
